import { render, staticRenderFns } from "./agree-scmb.vue?vue&type=template&id=3964e26d&scoped=true"
import script from "./agree-scmb.vue?vue&type=script&lang=ts"
export * from "./agree-scmb.vue?vue&type=script&lang=ts"
import style0 from "./agree-scmb.vue?vue&type=style&index=0&id=3964e26d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964e26d",
  null
  
)

export default component.exports